// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","viewsContainer":"vZoViHBhd0rUWhdaUMAMN","viewsHeading":"jr0WXESbUrjBEbW1RfEYQ","noViews":"_1L2JtLUqU86vdV39pBgdDz","viewsLink":"_2uJ-YpaHvKNjuoW9Vjf3N_"};